import { Component } from "react";

import "./style.scss";

class Option extends Component {
    render() {
        return (
            <div className={`option ${this.props.className}`} onClick={()=>this.props.onClick(this)}>{this.props.children}</div>
        )
    }
}

export default Option;